import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { useContext } from 'react';
import { MyContext } from './Contextapi';
import { styled } from '@mui/system';

const fontOptions = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Courier New',
  'Verdana',
  'Georgia',
  'Palatino',
  'Garamond',
  'Bookman',
  'Comic Sans MS',
];

const StyledFormControl = styled(FormControl)({
    width: '100%',
  });
  
  const StyledSelect = styled(Select)({
    '& .MuiSelect-root': {
      borderRadius: '10px',
      backgroundColor: '#f7f7f7',
      padding: '10px',
      '&:focus': {
        backgroundColor: '#e0e0e0',
      },
    },
  });
  

const FontSelector = () => {
  const [selectedFont, setSelectedFont] = useState('Arial');
  const {dropdownfont,setdropdownfont} = useContext(MyContext);

  const handleChange = (event) => {
    setSelectedFont(event.target.value);
    setdropdownfont(event.target.value)
  };

  return (
    <StyledFormControl>
    <InputLabel id="font-selector-label">Select Font</InputLabel>
    <StyledSelect
      labelId="font-selector-label"
      id="font-selector"
      value={selectedFont}
      onChange={handleChange}
    >
      {fontOptions.map((font, index) => (
        <MenuItem key={index} value={font}>
          {font}
        </MenuItem>
      ))}
    </StyledSelect>
  </StyledFormControl>
  );
};

export default FontSelector;